import styled from 'styled-components';

import { Dropdown } from '@sternum/ui';

import { LocalDropdown } from './LocalDropdown';

export const DropdownStyled = styled(LocalDropdown)`
  ${Dropdown.InnerComponents.ValueContainer} {
    padding: 0 12px 0 4px;
  }
  svg {
    transform: ${(props) => (props.isOpen ? 'rotate(0)' : 'rotate(180deg)')};
  }
`;
